module.exports = __webpack_public_path__ + "static/media/EmptyChat.7fbe158e.png";